<div [dlNodeVolger]="node" [cy]="cy" ankertype="rechtsonder" [offset]="{x: 5, y: 5}" [volgFormaat]="false" [schaalMetZoom]="false" [zichtbaarAls]="modelcanvas.nodeOverlaysZichtbaar" class="dl-nodemenu__holder" (pointerover)="opItemHover($event)" (pointerleave)="opMenuVerlaten()">
    <ul class="dl-nodemenu">
        <li class="dl-nodemenu__item" data-uitleg="derivative_value" (click)="uitvoerToggleDValue()" title="{{ 'TOGGLE_Q_VALUE' | translate }}">
            <a class="value_menuitem"></a>
        </li>
        @if (effectiefModelleerniveau >= 40 && (!condtag || condtag.state === 'cons')) {
            <li class="dl-nodemenu__item" (click)="toggleSubmenu('dz_correspondence_menu')" title="{{ 'CORR_SUBMENU' | translate }}">
                <a class="correspondence_general"></a>
            </li>
        }
        @if (effectiefModelleerniveau >= 40) {
            <li class="dl-nodemenu__item" (click)="toggleSubmenu('derivative_zero_ineq_menu')" title="{{ 'ZERO_SUBMENU' | translate }}">
                <a class="equal"></a>
            </li>
        }
        <li class="dl-nodemenu__separator dl-nodemenu__item"></li>
        <li class="dl-nodemenu__item" (click)="uitvoerEditBallon()" title="{{ 'BALLON.BTN_TITLE' | translate }}">
            <a class="fa_item"><span class="fa-regular fa-comment"></span></a>
        </li>
    </ul>
    @if (actievSubmenu() === 'dz_correspondence_menu') {
        <ul class="dl-nodemenu__submenu">
            @if (effectiefModelleerniveau >= 40 && (!condtag || condtag.state === 'cons')) {
                <li class="dl-nodemenu__item" data-uitleg="correspondence_dv_directed" [class.selectedMenuItem]="isActiefInitAddActie('correspondence_dv_directed')" (click)="uitvoerInitAddAction({type: 'correspondence_dv_directed'})" title="{{ 'ADD_CORR_NORMAL' | translate }}">
                    <a class="correspondence_directed"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="correspondence_dv_normal" [class.selectedMenuItem]="isActiefInitAddActie('correspondence_dv_normal')" (click)="uitvoerInitAddAction({type: 'correspondence_dv_normal'})" title="{{ 'ADD_CORR_NORMAL' | translate }}">
                    <a class="correspondence_normal"></a>
                </li>
            }
        </ul>
    }
    @if (actievSubmenu() === 'derivative_zero_ineq_menu') {
        <ul class="dl-nodemenu__submenu">
            <li class="dl-nodemenu__item" data-uitleg="d_ineq_lt" [class.selectedMenuItem]="isActiefInitAddActie('d_ineq_lt')" (click)="uitvoerInitAddAction({type: 'd_ineq_lt'})" title="{{ 'ADD_INEQ_LT' | translate }}">
                <a class="q_ineq_lt"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="d_ineq_lte" [class.selectedMenuItem]="isActiefInitAddActie('d_ineq_lte')" (click)="uitvoerInitAddAction({type: 'd_ineq_lte'})" title="{{ 'ADD_INEQ_LTE' | translate }}">
                <a class="q_ineq_lte"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="d_ineq_eq" [class.selectedMenuItem]="isActiefInitAddActie('d_ineq_eq')" (click)="uitvoerInitAddAction({type: 'd_ineq_eq'})" title="{{ 'ADD_INEQ_EQ' | translate }}">
                <a class="q_ineq_eq"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="d_ineq_gte" [class.selectedMenuItem]="isActiefInitAddActie('d_ineq_gte')" (click)="uitvoerInitAddAction({type: 'd_ineq_gte'})" title="{{ 'ADD_INEQ_GTE' | translate }}">
                <a class="q_ineq_gte"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="d_ineq_gt" [class.selectedMenuItem]="isActiefInitAddActie('d_ineq_gt')" (click)="uitvoerInitAddAction({type: 'd_ineq_gt'})" title="{{ 'ADD_INEQ_GT' | translate }}">
                <a class="q_ineq_gt"></a>
            </li>
        </ul>
    }
</div>
